import React from 'react';
import Tooltip from 'rc-tooltip';

export default function CustomCell({ longAnswer, shortAnswer, className }) {
  if (longAnswer?.length > 28) {
    return (
      <Tooltip
        destroyTooltipOnHide={false}
        overlayClassName="eds-rc-tooltip logs-table-tooltip over-modal"
        placement="top"
        overlay={longAnswer}
      >
        <div className={className}>{shortAnswer}</div>
      </Tooltip>
    );
  }
  return <div className={className}>{shortAnswer}</div>;
}
